import { render } from "./HausStep4.vue?vue&type=template&id=26277a52&scoped=true"
import script from "./HausStep4.vue?vue&type=script&lang=js"
export * from "./HausStep4.vue?vue&type=script&lang=js"

import "./HausStep4.vue?vue&type=style&index=0&id=26277a52&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26277a52"]])

export default __exports__